import { Subject } from 'rxjs/Subject';
import { HttpService } from '../core/http/http.service';
import { Injectable } from '@angular/core';

import { IProjectDetails, IAddress, IIdName, IStoreFloor } from '../_entities';

@Injectable()
export class ProjectService {

    public static projectUpdates$: Subject<any> = new Subject();

    constructor(private readonly httpService: HttpService) {}

    private projectStatusPromise: Promise<IIdName[]>;

    public getProject(storeId: number, projectCode: string): Promise<IProjectDetails> {
		return this.httpService.get<IProjectDetails>(`api/store/${storeId}/project/${projectCode}`);
	}

	public getProjectById(projectId: number): Promise<IProjectDetails> {
		return this.httpService.get<IProjectDetails>(`api/project/${projectId}`);
	}

	public addNewProject(storeId: number, projectInfo: IProjectDefinition): Promise<IProjectDetails> {
		return this.httpService.post<IProjectDetails>(`api/store/${storeId}/project`, projectInfo);
	}

	public addStoreFloor(projectId: number, premisesFloorId: number): Promise<IStoreFloor> {
		return this.httpService.post<IStoreFloor>(`/api/project/${projectId}/storefloor`, { premisesFloorId: premisesFloorId });
	}

	public deleteStoreFloor(storeFloorId: number): Promise<IStoreFloor[]> {
		return this.httpService.delete(`api/storefloor/${storeFloorId}`);
	}

	public activateStoreVersion(projectId: number): Promise<IProjectDetails> {
		return new Promise((resolve, reject) => {
			this.httpService.post<IProjectDetails>(`api/project/${projectId}/activatestoreversion`, {})
				.then(result => {
					ProjectService.projectUpdates$.next(false);
					resolve(result);
				}, error => reject(error));
		});
	}

	public patchStoreFloor(storeFloorId: number, prop: string, value: any): Promise<IStoreFloor> {
		const patches = [{ "op": "replace", "path": `/${prop}`, "value": value }];
		return this.httpService.patch<IStoreFloor>(`api/storefloor/${storeFloorId}`, patches);
	}


	patchProject(project: IProjectDetails, prop: string, value: any): Promise<IProjectDetails> {

		const patches = [{ "op": "replace", "path": `/${prop}`, "value": value }];

        return new Promise((resolve, reject) => {
			this.httpService.patch<IProjectDetails>(`api/store/${project.storeInfo.storeId}/project/${project.projectCode}`, patches)
                .then(result => {
                    ProjectService.projectUpdates$.next(false);
                    resolve(result);
                }, error => reject(error));
        });
    }

    addAddress(premisesIdentifier: string, project: IProjectDetails, address: {
        type: string;
        address1: string;
        address2?: string;
        postalCode: string;
        city: string;
        countryCode: string;
    }): Promise<IAddress> {
        return new Promise((resolve, reject) => {
            this.httpService.post<IAddress>(this.getProjectUrl(premisesIdentifier, project.projectCode, "address"), address)
                .then(result => {
                    resolve(result);
                }, error => reject(error));
        });
    }
    
    private getProjectUrl(premisesIdentifier: string, projectCode: string, path: string = "") {
        return "/api/" + premisesIdentifier + "/project/" + projectCode + "/" + path;
	}

	get statuses(): Promise<IIdName[]> {

        if (!this.projectStatusPromise) {
            this.projectStatusPromise = this.httpService.get<IIdName[]>("api/support/projectstatus");
            return this.projectStatusPromise;
            //this.projectStatusPromise = Promise.resolve([{ id: 1, name: 'Possible' }, { id: 2, name: 'Decided' }, { id: 3, name: 'Approved' }]);
		}
        return this.projectStatusPromise;
	}

}

export interface IProjectDefinition {
    brandCode: string;
    storeFormat: string;
	storeClassCode: string;
	classificationCode: string;
    projectAction: string;
    projectStatus: string;
    finishingDate: Date;
	invoiceCode: string;
	floors: any[];
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/project.service.ts